import script from "./LightItemModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LightItemModal.vue?vue&type=script&setup=true&lang=js"

import "./LightItemModal.vue?vue&type=style&index=0&id=5b41d8e9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b41d8e9"]])

export default __exports__